module.exports = __webpack_public_path__ + "static/media/qryFuncIcon.2cfb3e0c.svg";